import AdminMicrosoftTeamsSettings from './AdminMicrosoftTeamsSettings';
export default AdminMicrosoftTeamsSettings;
